import { __assign } from "tslib";
import React from 'react';
import PaymentStatusComponent from '../../../../OrderCard/components/PaymentStatus/PaymentStatus';
import WaitPaymentText from '../OrderStatus/OrderStatusText/WaitPaymentText/WaitPaymentText';
var PaymentStatus = function (props) {
    return React.createElement(PaymentStatusComponent, __assign({}, props, { text: React.createElement(WaitPaymentText, null) }));
};
export default PaymentStatus;
